<div class="flex flex-col bg-card overflow-hidden">
  <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-2 pb-2 border-b flex items-center">
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="property" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div *ngIf="!changeTitleMode" class="font-bold text-md text-secondary uppercase tracking-wider">
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto" *ngIf="canEditPanelDef">
      <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCard09Menu">
        <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
      </button>
      <mat-menu #listCard09Menu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
      </mat-menu>
      <button
        class="cancel-button"
        mat-icon-button
        type="button"
        *ngIf="changeTitleMode"
        [matTooltip]="'Cancel'"
        (click)="toggleEditMode(false)"
      >
        <mat-icon [svgIcon]="'cancel'"></mat-icon>
      </button>
      <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon [svgIcon]="'save'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col gt-xs:flex-row items-start">
    <div class="flex items-center my-3 xs:hidden absolute gt-md:z-10 bg-white ml-2">
      <div class="p-2 leading-none border border-r-0">
        <div
          class="font-bold text-xs text-hint uppercase tracking-wider"
          (click)="changeMapStyle('mapbox://styles/mapbox/streets-v9')"
        >
          Streets
        </div>
      </div>
      <div class="p-2 leading-none border border-r-0">
        <div
          class="font-bold text-xs text-hint uppercase tracking-wider"
          (click)="changeMapStyle('mapbox://styles/mapbox/satellite-streets-v11')"
        >
          Satellite
        </div>
      </div>
    </div>
    <mgl-map [style]="selectedMapStyle" [zoom]="[9]" [minZoom]="4" [projection]="'mercator'" [center]="[lng, lat]">
      <mgl-control mglFullscreen></mgl-control>
      @if (!isAddressHidden) {
        <mgl-marker [lngLat]="[property.address?.longitude, property.address?.latitude]">
          <img src="assets/images/map/red-marker.png" style="width: 20px" />
        </mgl-marker>
      }
      <ng-container *ngFor="let layer of layers">
        <mgl-geojson-source [id]="layer.id" [data]="layer.url"> </mgl-geojson-source>
        <mgl-layer
          [id]="layer.id"
          [source]="layer.id"
          [type]="layer.type"
          (click)="onLayerClick($event, layer)"
          [paint]="{
            'circle-color': 'red',
          }"
        ></mgl-layer>
      </ng-container>
      <mgl-popup *ngIf="selectedLayerPoint?.properties" [lngLat]="selectedLayerPoint?.lngLat">
        <div class="flex flex-col max-w-80 w-full filter-article">
          <div class="m-1">
            <div class="mt-2">
              <div class="flex flex-wrap items-left flex-col text-secondary my-1">
                <div *ngFor="let property of selectedLayerPoint?.properties | keyvalue">
                  <span class="font-semibold leading-tight">{{ property?.key }}:</span>
                  {{ property?.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mgl-popup>
    </mgl-map>
  </div>
  <div class="flex flex-col">
    @if (newTable) {
      <ts-table [columnDefs]="columnDefs" [rowData]="properties" [actions]="actions"> </ts-table>
    } @else {
      <table
        class="w-full bg-transparent"
        mat-table
        matSort
        [dataSource]="properties"
        [trackBy]="trackByFn"
        #addressTable
      >
        <!-- Date -->
        <ng-container matColumnDef="address">
          <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
            <span class="whitespace-nowrap"> Address </span>
          </th>
          <td mat-cell *matCellDef="let property">
            <span class="address-container flex flex-col">
              <div class="pr-6 whitespace-nowrap address-string">
                <span
                  class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
                  *ngIf="property.livability_score && property.livability_score > 0"
                  [ngClass]="[
                    property.livability_score >= 80 ? 'green-100' : '',
                    property.livability_score < 80 && property.livability_score >= 40 ? 'orange-100' : '',
                    property.livability_score < 40 ? 'red-300' : '',
                  ]"
                >
                  <span class="leading-relaxed whitespace-nowrap">{{ property.livability_score }}</span>
                </span>
                <span>
                  {{ property?.address?.address_string || 'Address Missing' }}
                </span>
              </div>
              <div class="text-sm text-hint">
                {{ property.property_type?.name }} •
                <span *ngIf="property.apn">{{ property.apn }} • </span>
                <span *ngIf="property.year_built">Built in {{ property.year_built }} • </span>
                <span *ngIf="property.unit_size">{{ property.unit_size }} Units • </span>
                <span *ngIf="property.rentable_sq_ft && property.rentable_sq_ft > 0"
                  >{{ property.rentable_sq_ft | formatNumber: 0 }} SF •
                </span>
                <span *ngIf="property.parcel_size && property.parcel_size > 0"
                  >{{ property.parcel_size | formatNumber: 2 }} Acres •
                </span>
                <span *ngIf="property.last_sale_price && property.last_sale_price > 0">
                  Last Sale: {{ property.last_sale_price | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                  <span *ngIf="property.last_sale_date"> on {{ property.last_sale_date | formatDate }} </span>
                </span>
              </div>
            </span>
          </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear></th>
          <td mat-cell *matCellDef="let property">
            <div class="flex flex-row justify-end">
              <!-- Visualization Menu -->
              <button
                class="more-menu"
                mat-icon-button
                [matMenuTriggerFor]="visualizationMenu"
                [matTooltip]="'View on...'"
              >
                <mat-icon [svgIcon]="'language'"></mat-icon>
              </button>
              <mat-menu #visualizationMenu="matMenu">
                <section class="flex flex-col">
                  <!-- Google Earth -->
                  <a
                    class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                    href="https://earth.google.com/web/@{{ property.address?.latitude }},{{
                      property.address?.longitude
                    }},{{ googleEarthConfig.cameraAltitude }}d,{{ googleEarthConfig.zoom }}z"
                    target="_blank"
                    [matTooltip]="'View on Google Earth'"
                    [matTooltipPosition]="'right'"
                  >
                    <mat-icon class="icon-size-20 mr-1" [svgIcon]="'public'"></mat-icon>
                    Google Earth
                  </a>
                  <!-- Google Maps -->
                  <a
                    class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                    href="https://www.google.com/maps?q=loc:{{ property.address?.latitude }}+{{
                      property.address?.longitude
                    }}&ll={{ property.address?.latitude }},{{ property.address?.longitude }}&t=h"
                    target="_blank"
                    [matTooltip]="'View on Google Maps'"
                    [matTooltipPosition]="'right'"
                  >
                    <mat-icon class="icon-size-20 mr-1" [svgIcon]="'location_on'"></mat-icon>
                    Google Maps
                  </a>
                  <!-- Parcel Map -->
                  <a
                    class="mat-focus-indicator mat-icon-button mat-button-base w-full py-0 px-3 flex justify-between"
                    (click)="goToResearch(property)"
                    [matTooltip]="'View on Parcel Map'"
                    [matTooltipPosition]="'left'"
                  >
                    <mat-icon class="icon-size-20 mr-1" [svgIcon]="'map'"></mat-icon>
                    Parcel Map
                  </a>
                </section>
              </mat-menu>

              <!-- Demographics -->
              <a
                class="mat-focus-indicator mat-icon-button mat-button-base"
                (click)="openDemographicDialog(property)"
                [matTooltip]="'View Demographics'"
              >
                <mat-icon class="icon-size-20 mr-1" [svgIcon]="'supervisor_account'"></mat-icon>
              </a>

              <!-- More Menu -->
              <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" [matTooltip]="'More'">
                <mat-icon [svgIcon]="'more_vert'"></mat-icon>
              </button>
              <mat-menu #moreMenu="matMenu">
                <button
                  mat-menu-item
                  (click)="openAddressDialog(property.address)"
                  [appAuthorize]="[NewPermission.PROPERTIES_EDIT, property.permissions?.is_editable]"
                  denyAction="disable"
                >
                  <mat-icon [svgIcon]="'edit'"></mat-icon>
                  Edit
                </button>
                <button
                  mat-menu-item
                  (click)="deleteProperty(property)"
                  [appAuthorize]="[NewPermission.PROPERTIES_EDIT, property.permissions?.is_editable]"
                  denyAction="disable"
                >
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
      </table>
    }
  </div>
</div>
